<template>
  <div class="bg-white p-6">
    <div class="flex flex-col mb-6">
      <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Nama Merchant</label>
      <p class="text-neutral-500">Merchant 1</p>
    </div>

    <div class="flex flex-col mb-6">
      <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Alamat</label>
      <p class="text-neutral-500">Jl.Lebak Bulus 1 No.16, kelurahan lebak bulus, kecamatan cilandak, jakarta selatan</p>
    </div>

    <div class="flex flex-col mb-6">
      <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Total Order</label>
      <p class="text-neutral-500">5</p>
    </div>

    <div class="flex flex-col mb-6">
      <label class="text-sm text-neutral-700 font-medium mb-1 inline-block">Total Price</label>
      <p class="text-neutral-500">14.000</p>
    </div>

    <div class="flex items-center tab shadow-border-b mt-20">
      <div class="px-6 py-3 relative cursor-pointer "
        :class="[tab.isActive ? 'text-neutral-700 font-medium active' : 'text-neutral-500']" v-for="tab in tabList"
        :key="tab.title" @click="selectTab(tab)">
        {{ tab.title }}
      </div>
    </div>
    <div class="content px-6 py-10">
      <component :is="selectedTab.content" />
    </div>

  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters('master', ['goodsCategoryDetail']),
    goodCategoryCode() {
      return this.$route.params.id
    }
  },
  created() {
    this.getGoodCategoryInfo()
  },
  methods: {
    ...mapActions('master', ['getGoodsCategoryDetail']),
    getGoodCategoryInfo() {
      this.getGoodsCategoryDetail({
        code: this.goodCategoryCode
      })
    },
    selectTab(tab) {
      this.tabList.forEach(item => (item.isActive = false))
      const tabIndex = this.tabList.findIndex(item => item.title === tab.title)
      this.tabList[tabIndex].isActive = true
      this.selectedTab = tab
    }
  },
  data: () => ({
    tabList: [
      {
        title: 'Transaksi Pending',
        content: () => import(/* webpackChunkName: "PendingTransaction" */ '@/views/Invoice/PendingTransaction'),
        isActive: false
      },
      {
        title: 'Transaksi Terbayar',
        content: () => import(/* webpackChunkName: "InfoUser" */ '@/views/Invoice/PaidTransaction'),
        isActive: false
      },
      {
        title: 'History Invoice',
        content: () => import(/* webpackChunkName: "InfoUser" */ '@/views/Invoice/InvoiceHistory'),
        isActive: false
      }
    ],
    selectedTab: ''
  }),
  mounted() {
    this.selectTab(this.tabList[0])
  },
}
</script>
<style lang="scss" scoped>
.tab {
  .active {
    &::after {
      content: '';
      display: block;
      height: 4px;
      width: 100%;
      background-color: #61d7cf;
      position: absolute;
      left: 0;
      bottom: 0;
      border-top-left-radius: 3px;
      border-top-right-radius: 3px;
    }
  }
}
</style>
